import applicationRoutes from '@/modules/applications/routes'
import userRoutes from '@/modules/users/routes'
import roleRoutes from '@/modules/roles/routes'
import permissionRoutes from '@/modules/permissions/routes'
import interfacesRoutes from '@/modules/interfaces/routes'
import userRequestRoutes from '@/modules/userRequest/routes'

const routes = [
  {
    path: '/',
    meta: {
      authorization: {
        authenticated: true,
      },
    },
    component: () => import('@/views/layouts/DynamicLayout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/Home.vue'),
      },
      ...applicationRoutes,
      ...userRoutes,
      ...roleRoutes,
      ...permissionRoutes,
      ...interfacesRoutes,
      ...userRequestRoutes
    ],
  },

  {
    path: '*',
    redirect: { name: 'home' },
  },
]

export default routes
